/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectDataDto } from '../../models/backend-project-data-dto';

export interface MlMlProjectsRetrieve$Params {}

export function mlMlProjectsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: MlMlProjectsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectDataDto>> {
  const rb = new RequestBuilder(rootUrl, mlMlProjectsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectDataDto>;
    }),
  );
}

mlMlProjectsRetrieve.PATH = '/api/ml/ml_projects/';
